import React from 'react';
import Divider from '@material-ui/core/Divider';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'none',
    color: theme.palette.borders.primary,
    width: 1,
    height: 39,
    margin: '0 8px 0 8px',
    [theme.breakpoints.up('md')]: {
      display: 'block'
    }
  }
}));

const NavBarDivider = () => {
  const classes = useStyles();
  return <Divider orientation="vertical" className={classes.root} />;
};

NavBarDivider.propTypes = {
  classes: PropTypes.shape({})
};

export default NavBarDivider;
